module.exports = __webpack_public_path__ + "assets/img/sabc_video_list_play_icon.png?69739fc51412817bb8e47522bbb2b43f";